import { Node } from 'slate';

export const IMAGE_TOGGLE = 'image-toggle';

export type ImageToggleOptions = {
  isReadOnly?: boolean;
  [key: string]: any;
};

export type ImageToggleNode = {
  visible: boolean;
  toggle: boolean;
  label?: string;
  image?: {
    url: string;
    uploadedDate: string | number | Date;
    size: number;
  };
} & Node;
